// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.header-info[data-v-38fd46bc] {\n  margin-bottom: 12px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 24px;\n  color: #606266;\n}\n", ""]);
// Exports
module.exports = exports;
